import "./social-icons-box-component-styles.scss";

// importing icons
import {
	AiFillLinkedin,
	AiFillInstagram,
	AiOutlineTwitter,
} from "react-icons/ai";
import { BsGithub } from "react-icons/bs";
import { FaDev } from "react-icons/fa";

// importing component
import SocialIconComponent from "../../components/social-icon-component/social-icon-component";

const SocialIconsBoxComponent = () => {
	// social links
	const socialIconDetails = [
		{
			title: "GitHub",
			icon: <BsGithub />,
			link: "https://github.com/moazamdev",
		},
		{
			title: "LinkedIn",
			icon: <AiFillLinkedin />,
			link: "https://www.linkedin.com/in/moazamdev/",
		},
		{
			title: "Dev Community",
			icon: <FaDev />,
			link: "https://dev.to/moazamdev",
		},
		{
			title: "Instagram",
			icon: <AiFillInstagram />,
			link: "https://www.instagram.com/moazam.dev/",
		},
		{
			title: "Twitter",
			icon: <AiOutlineTwitter />,
			link: "https://twitter.com/moazamdev",
		},
	];

	return (
		<div className="social-icons-box">
			<ul
				className="icons-list"
			>
				{socialIconDetails.map((icon) => (
					<SocialIconComponent
						title={icon.title}
						icon={icon.icon}
						link={icon.link}
						key={icon.title}
					/>
				))}
			</ul>
		</div>
	);
};

export default SocialIconsBoxComponent;
